import { getApp } from 'firebase/app';
import { getFunctions, httpsCallable } from 'firebase/functions';

export interface JoinCodeLookup {
  grade: number | string | null;
  class: number | string | null;
  schoolId: string | null;
  classId: string | null;
  subjectId: string | null;
  schoolName: string | null;
}

/** 학급·교과 코드 전체 목록을 열지 않고, 입력한 코드 한 건만 서버에서 찾습니다. */
export async function lookupJoinCode(
  kind: 'class' | 'subject',
  code: string
): Promise<JoinCodeLookup | null> {
  const functions = getFunctions(getApp());
  const callable = httpsCallable<{ kind: 'class' | 'subject'; code: string }, JoinCodeLookup>(
    functions,
    'lookupJoinCode'
  );
  try {
    const result = await callable({ kind, code: code.trim() });
    return result.data;
  } catch (error: unknown) {
    const codeName = typeof error === 'object' && error && 'code' in error ? String((error as { code: string }).code) : '';
    if (codeName === 'functions/not-found') return null;
    throw error;
  }
}
